import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import type { InternalLinkInterface } from '@/types';
import { urlBuilder } from '@/utils';

interface NavLinkProps {
  internalLink?: InternalLinkInterface;
  externalLink?: string;
  className?: string;
  activeClassName?: string;
  children: React.ReactNode;
  ariaLabel?: string;
  tabIndex?: number;
}

function NavLink({
  internalLink,
  externalLink,
  className,
  children,
  activeClassName,
  ariaLabel = '',
  tabIndex = 0,
}: NavLinkProps) {
  if (internalLink) {
    return (
      <GatsbyLink
        to={urlBuilder(internalLink)}
        className={className}
        activeClassName={activeClassName}
        {...(ariaLabel && { 'aria-label': ariaLabel })}
        tabIndex={tabIndex}
      >
        {children}
      </GatsbyLink>
    );
  } else if (externalLink) {
    return (
      <a
        href={externalLink}
        className={className}
        target='_blank'
        rel='noreferrer'
        {...(ariaLabel && { 'aria-label': ariaLabel })}
        tabIndex={tabIndex}
      >
        {children}
      </a>
    );
  }
}

export default NavLink;
